import { useAuth } from 'app/provider/auth'
import { GroupsScreen } from './groups-screen'
import { useSuggestedGroupsQuery } from './queries'
import {
  useUserGroupJoinRequestsQuery,
  useUserGroupsQuery,
  userGroupJoinRequestsQuery,
  userGroupsQuery,
} from '../../queries'
import { useState } from 'react'

export interface GroupsScreenContainerProps {
  HeaderComponent?: React.ReactNode
}

export const GroupsScreenContainer = (props: GroupsScreenContainerProps) => {
  const { user } = useAuth()
  const [refreshing, setRefreshing] = useState(false)

  const {
    data: userGroupsData,
    refetch: refetchUserGroups,
    networkStatus: userGroupsNetworkStatus,
  } = useUserGroupsQuery({
    variables: {
      ...userGroupsQuery.defaultVariables,
    },
    skip: !user,
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
  })

  const { data: userGroupJoinRequestsData } = useUserGroupJoinRequestsQuery({
    variables: {
      ...userGroupJoinRequestsQuery.defaultVariables,
    },
    fetchPolicy: 'cache-and-network',
    skip: !user,
  })

  const {
    data: suggestedGroupsData,
    refetch: refetchSuggested,
    networkStatus: suggestedGroupsNetworkStatus,
  } = useSuggestedGroupsQuery(
    {
      limit: 10,
    },
    {
      skip: !user,
      fetchPolicy: 'cache-and-network',
      notifyOnNetworkStatusChange: true,
    }
  )

  const handlePullToRefresh = async () => {
    setRefreshing(true)
    await Promise.all([refetchUserGroups(), refetchSuggested()])
    setRefreshing(false)
  }

  const userCreatedGroups = userGroupsData?.userGroups?.docs?.filter((group) => group.isOwner) || []
  const userJoinedGroups = userGroupsData?.userGroups?.docs?.filter((group) => !group.isOwner) || []
  const suggestedGroups = suggestedGroupsData?.suggestedGroups?.docs.slice(0, 2) || []
  const userGroupJoinRequests = userGroupJoinRequestsData?.userGroupJoinRequests?.docs || []

  return (
    <GroupsScreen
      HeaderComponent={props.HeaderComponent}
      userCreatedGroups={userCreatedGroups}
      userJoinedGroups={userJoinedGroups}
      userGroupJoinRequests={userGroupJoinRequests}
      userJoinedGroupsLoading={userGroupsNetworkStatus === 1}
      suggestedGroupsLoading={suggestedGroupsNetworkStatus === 1}
      suggestedGroups={suggestedGroups}
      user={user}
      refreshing={refreshing}
      onPullToRefresh={handlePullToRefresh}
    />
  )
}
